import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-report-template.dto';
export * from './dtos/report-template-list.dto';
export * from './dtos/report-template-record.dto';
export * from './dtos/report-template-search.dto';
export * from './dtos/report-templates-stats.dto';
export * from './dtos/update-report-template.dto';

export * from './enums/report-template-type.enum';

export * from './types/report-templates-filters';

export * from './validators/functions/can-create-or-update.function';
export * from './validators/schemas/create-report-template.schema';
export * from './validators/schemas/update-report-template.schema';

export const reportTemplateValidators = { canCreateOrUpdate };
